/* @todo remove polyfills when we can drop support for IE10 **/
import 'core-js/modules/es6.set';
import 'core-js/modules/es6.map';

import '@ratedpeople/utils/sass/main.scss';
